module.exports = __webpack_public_path__ + "static/media/start.959b8a6e.mp3";